// const { default: common } = require('./common');
const { default: ViewerTool } = require('./ViewerTool');
const { default: date } = require('./date');
const { default: gender } = require('./gender');
const { default: status } = require('./status');
const { default: messageConstant } = require('./message.constant');
const { default: vi } = require('./vi');

module.exports = {
  ...gender,
  ...date,
  ...status,
  ...vi,
  ...messageConstant,
  ...ViewerTool,
  // ...common,
};
